/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_80b68868{margin:10px 0}.exampleLabel_80b68868{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_80b68868";
export const exampleLabel = "exampleLabel_80b68868";